module.exports = __webpack_public_path__ + "7c70c87f424b89e1e875c6552196d45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicon.png
// module id = 1688
// module chunks = 0